<div
  class="backdrop"
  [class.backdrop--closing]="closing()"
  aria-hidden="true"
  (click)="onBackdropClick()"
></div>

<div
  class="panel"
  [class.panel--drawer]="isDrawer()"
  [class.panel--closing]="closing()"
  [class.panel--sm]="size() === 'sm' && !customInlineSize()"
  [class.panel--lg]="size() === 'lg' && !customInlineSize()"
  [style.--dialog-inline-size]="customInlineSize()"
  [style.--dialog-block-size]="customBlockSize()"
  role="dialog"
  aria-modal="true"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  [attr.aria-labelledby]="heading() ? titleId : null"
  [attr.aria-label]="heading() ? null : ariaLabel() || null"
  (keydown.escape)="onEscape($event)"
>
  <header
    class="header"
    [class.header--align-start]="headingAlign() === 'start' || headingAlign() === 'left'"
    [class.header--has-back]="showBack()"
  >
    @if (showBack()) {
      <button
        type="button"
        class="back-btn"
        aria-label="Voltar"
        (click)="backRequest.emit()"
      >
        <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
      </button>
    }

    @if (isDrawer()) {
      <div class="top">
        <span class="eyebrow">{{ eyebrow() }}</span>
        <ng-container [ngTemplateOutlet]="closeButton" />
      </div>
    }

    @if (heading()) {
      <h2
        class="title"
        [id]="titleId"
        [style.font-size]="customHeadingSize()"
        [style.color]="headingColor()"
      >
        {{ heading() }}
      </h2>
    }

    @if (!isDrawer()) {
      <ng-container [ngTemplateOutlet]="closeButton" />
    }

    <div class="extra"><ng-content select="[dialog-header]" /></div>
  </header>

  <div class="body"><ng-content /></div>

  <footer class="footer"><ng-content select="[dialog-footer]" /></footer>
</div>

<ng-template #closeButton>
  <button type="button" class="close" aria-label="Fechar" [disabled]="disableClose()" (click)="requestClose()">
    <i class="fa-solid fa-xmark" aria-hidden="true"></i>
  </button>
</ng-template>
